import { BodyText, TitleText } from '@policygenius/mortar';
import classnames from 'classnames';
import { useState } from 'react';
import { createUseStyles } from 'react-jss';

import Button from 'components/Button';

import { ANALYTICS_SOURCE, HEADING, OPTIONS, SIGN_OUT_URL, SUBHEADING } from './constants';
import styles from './styles';
import { LabelProps, SelectUserOption, SelectUserProps } from './types';
import trackSelectedOption from './utils/trackSelectedOption';

const useStyles = createUseStyles(styles);

const Label = ({ firstName, option }: LabelProps) => (
  <BodyText as="span" size="large">
    {"I'm shopping for "}
    <BodyText as="strong" size="large" weight="bold">
      {option}
      {option === SelectUserOption.Myself && firstName ? ` (${firstName})` : ''}
    </BodyText>
  </BodyText>
);

const SelectUser = ({ firstName, setShowSelectUser }: SelectUserProps) => {
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState<SelectUserOption>();

  const onSubmit = () => {
    trackSelectedOption(selectedOption);
    if (selectedOption === SelectUserOption.Myself) {
      setShowSelectUser(false);
    } else {
      window.open(SIGN_OUT_URL, '_self');
    }
  };

  return (
    <div className={classes.wrapper}>
      <fieldset className={classes.options}>
        <legend id={ANALYTICS_SOURCE} className={classes.heading}>
          <TitleText size={{ small: 'large', medium: 'xlarge', large: 'xlarge' }} as="p">
            {HEADING}
          </TitleText>
          <BodyText
            size={{ small: 'medium', medium: 'large', large: 'large' }}
            className={classes.subHeading}
          >
            {SUBHEADING}
          </BodyText>
        </legend>
        {OPTIONS.map((option, index) => {
          const radioItemId = `${ANALYTICS_SOURCE}-item-${index}`;
          const selected = selectedOption === option;

          return (
            <div
              className={classnames(classes.radio, { [classes.radioSelected]: selected })}
              key={option}
            >
              <input
                className={classes.input}
                type="radio"
                id={radioItemId}
                name={ANALYTICS_SOURCE}
                checked={selected}
                onChange={() => setSelectedOption(option)}
              />

              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor={radioItemId}>
                <Label option={option} firstName={firstName} />
              </label>
            </div>
          );
        })}
      </fieldset>
      <Button
        analyticsProps={{
          source: ANALYTICS_SOURCE,
          text: 'Continue',
        }}
        className={classes.continueButton}
        disabled={!selectedOption}
        id={`${ANALYTICS_SOURCE}-submit`}
        onClick={onSubmit}
      >
        Continue
      </Button>
    </div>
  );
};

export default SelectUser;
